import { Typography } from '@mui/material';

import { ExternalIdFragment } from '../../types/externalId';
import { AxleChip } from '../displayFields/chips';
import { HorizontalStack, VerticalStack } from '../utils/linearLayouts';

export const ExternalIdContentDisplay = ({
    externalId,
    externalLink,
}: {
    externalId: string | null;
    externalLink?: string | null;
}) => {
    const hasId = !!externalId;
    return (
        <HorizontalStack spacing={1}>
            <AxleChip
                label={hasId ? externalId : 'None'}
                copyToClipboardValue={externalId ?? undefined}
                link={externalLink ?? undefined}
            />
        </HorizontalStack>
    );
};

export const ExternalIdDisplay = ({
    externalId,
    externalLink,
    externalIds,
    label = true,
}: {
    externalId: string | null;
    externalLink?: string | null;
    externalIds: ExternalIdFragment[] | null;
    label?: boolean;
}) => {
    const singleId = externalIds && externalIds.length > 0 ? externalIds[0].value : externalId;
    return (
        <VerticalStack>
            {label ? <Typography variant='caption'>External ID</Typography> : null}
            <ExternalIdContentDisplay externalId={singleId} externalLink={externalLink} />
        </VerticalStack>
    );
};

export const InlineExternalIdDisplay = ({ externalId }: { externalId: string | null }) => {
    const hasId = !!externalId;
    return (
        <AxleChip
            label={`External ID: ${hasId ? externalId : 'None'}`}
            copyToClipboardValue={externalId ?? undefined}
        />
    );
};
